import ComposeMessage from './ComposeMessage';

export default ComposeMessage;



// WEBPACK FOOTER //
// ./src/components/ComposeMessage/index.jsx